import MiniDrawer from "./MiniDrawer";

export default MiniDrawer;
